module.exports = __webpack_public_path__ + "static/recipe-collect-4-641352aaddcd9f990c5d04e129200d62.jpeg";